<template>
<a-modal width="50%" title="专家确认" :visible="visible"  :destroy-on-close="true"
    :mask-closable="false"
    :confirm-loading="confirmLoading" @cancel="onClose" @ok="onSubmit">
    <a-form ref="ruleForm" layout="vertical" :model="form" :rules="rules">
        <a-list size="small" :data-source="fileList">
            <template #header>
                <div>补充文件列表</div>
            </template>
            <template #renderItem="{ item }">
                <a-list-item>
                    <div class="listItem">
                        <div>
                            <a target="_blank" :href="fileUrl+item" :title="item.split('|')[1]">
                                {{ item.split('|')[1] }}
                            </a>
                        </div>
                        <div>
                            <a target="_blank" :href="fileUrl+item">下载</a>
                        </div>
                    </div>
                </a-list-item>
            </template>
        </a-list>
        <br>

        <a-form-item label="其他专家意见" name="otherAdvise" v-if="adviseList.length>0">
            <a-timeline style="margin-top: 25px">
                <a-timeline-item v-for="item in adviseList" :key="item.id">
                    <div v-if="item.auditTime">
                        <div>{{ item.expertName }}<span style="margin-left: 20px">{{ item.auditTime }}</span></div>
                        <div style="background-color: rgb(248, 248, 248);">
                            <p style="color: #00cc00" v-if="item.auditResult===1">通过</p>
                            <p style="color: #ff0000" v-if="item.auditResult===0">驳回</p>
                            <p>{{ item.auditResult===1?"通过":"驳回" }}意见: {{ item.auditAdvise }}</p>
                        </div>
                    </div>
                    <div v-else>
                        <div>{{ item.expertName }}</div>
                        <div>
                            待处理
                        </div>
                    </div>
                </a-timeline-item>
            </a-timeline>
<!--            <div v-for="item in adviseList" :key="item.id">-->
<!--                <div>{{ item.expertName }}<span style="margin-left: 20px">{{ item.auditTime }}</span></div>-->
<!--                <div style="background-color: rgb(248, 248, 248);">-->
<!--                    <p style="color: #00cc00" v-if="item.auditResult===1">通过</p>-->
<!--                    <p style="color: #ff0000" v-if="item.auditResult===0">驳回</p>-->
<!--                    <p>{{ item.auditResult===1?"通过":"驳回" }}意见: {{ item.auditAdvise }}</p>-->
<!--                </div>-->
<!--            </div>-->
        </a-form-item>

        <a-form-item label="资料审核结果" name="auditResult">
            <a-radio-group v-model:value="form.auditResult">
                <a-radio value="0">驳回</a-radio>
                <a-radio value="1">通过</a-radio>
            </a-radio-group>
        </a-form-item>

        <a-form-item label="资料审核意见" name="auditAdvise" v-if="form.auditResult==='0'">
            <a-textarea v-model:value="form.auditAdvise"/>
        </a-form-item>
        <img v-if="form.auditResult==='1' && !!expert.signatureFile" width="140" :src="getImg(expert.signatureFile)" alt=""/>
    </a-form>

<!--    <template #footer>
        <a-button key="back" @click="onDeny">驳回</a-button>
        <a-button key="submit" type="primary" @click="onPass">通过</a-button>
    </template>-->
<!--    <a-modal v-model:visible="visible" title="Title" @ok="handleOk">
        <template #footer>
            <a-button key="submit" type="primary" :loading="loading" @click="handleOk">Submit</a-button>
        </template>
        <p>Some contents...</p>
    </a-modal>-->
    <no-signature-file-modal ref="noSign"></no-signature-file-modal>
</a-modal>
</template>

<script>
import {formMixin} from "@/mixins";
import dataCheck from "@/utils/dataCheck";
import { file_service } from "@/api/adminService";
import {confirm, expert} from "@/api/projectReviewService"
import NoSignatureFileModal from "./NoSignatureFileModal.vue";

export default {
    name: "ConfirmModal",
    components: {NoSignatureFileModal},
    mixins: [formMixin],
    watch:{
        "form.fileStr"(n){
            console.log(n)
            if (n){
                this.fileList = n.split(",")
            }
        },
        visible(n){
            if (n){
                this.getConfirm()
                this.getCurrentExpertInfo()
            }
        },
        "form.auditResult"(n){
            if (n==='0'){
                this.rules.auditAdvise=[dataCheck.required({})]
            }
        }
    },
    data(){
        return {
            fileUrl:file_service.download,
            fileList:[],
            form:{
                fileStr:'',
                auditAdvise:'',
                auditResult: 0
            },
            rules:{
                auditResult:[dataCheck.required({})],
                auditAdvise:[]
            },
            adviseList:[],
            expert:{},
            hasSignFile:false
        }
    },
    methods:{
        onDeny(){
            this.postAction({
                url:confirm.save,
                params:{
                    applicationId: this.form.applicationId,
                    batch: this.form.batch,
                    auditResult: 0,
                    auditAdvise: this.form.auditAdvise
                }
            }).then(resp=>{
                if (resp){
                    this.$notification.success({
                        message: '提示',
                        description: '提交成功',
                    });
                    this.onClose()
                    this.$emit('finish');
                }else{
                    this.$message.warning("提交失败");
                }

            })
        },
        onPass(){
            this.postAction({
                url:confirm.save,
                params:{
                    applicationId: this.form.applicationId,
                    batch: this.form.batch,
                    auditResult: 1,
                    auditAdvise: this.form.auditAdvise
                }
            }).then(resp=>{
                if (resp){
                    this.$notification.success({
                        message: '提示',
                        description: '提交成功',
                    });
                    this.onClose()
                    this.$emit('finish');
                }else{
                    this.$message.warning("提交失败");
                }
            })
        },
        getConfirm(){
            this.getAction({
                url: confirm.other,
                params:{
                    applicationId: this.form.applicationId,
                    batch:this.form.batch
                }
            }).then(resp=>{
                this.adviseList = resp
            })
        },
        onSubmit(){
            if (!this.hasSignFile){
                const refEle = this.$refs['noSign'];
                refEle.visible = true
                return;
            }
            if (this.form.auditResult==='0'){
                this.onDeny()
            }
            if (this.form.auditResult==='1'){
                this.onPass()
            }
        },
        getCurrentExpertInfo(){
            this.getAction({
                url: expert.current,
                params:{}
            }).then(resp=>{
                this.expert = resp
                const refEle = this.$refs['noSign'];
                refEle.visible = !resp.signatureFile
                this.hasSignFile = !!resp.signatureFile
            })
        },
        getImg(imgUrl) {
            return file_service.imagesWeb(imgUrl)
        },
    }
}
</script>

<style scoped>
.listItem{
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    flex-wrap: nowrap;
    width: 100%;
}
:deep(.ant-upload-list-item){
    margin-top: 0;
}
</style>
